module.exports = __webpack_public_path__ + "static/img/right-btn-bg.423c3423.png";